<!-- <table id="dataTabled" class="table table-bordered" width="100%" cellspacing="0">
  <thead>
    <tr>
      <th>{{ bookI18n?.isbnI18n }}</th>
      <th>{{ bookI18n?.titleI18n }}</th>
      <th>{{ bookI18n?.authorI18n }}</th>
      <th>{{ bookI18n?.categoryI18n }}</th>
      <th>{{ bookI18n?.publisherI18n }}</th>
      <th></th>
    </tr>
  </thead>
  <tfoot>
    <tr>
      <th>
        {{ bookI18n?.isbnI18n }}
      </th>
      <th>{{ bookI18n?.titleI18n }}</th>
      <th>{{ bookI18n?.authorI18n }}</th>
      <th>
        {{ bookI18n?.categoryI18n }}
      </th>
      <th>{{ bookI18n?.publisherI18n }}</th>
      <th></th>
    </tr>
  </tfoot>
  <tbody>
    <tr *ngFor="let b of books">
      <td>
        <span class="badge badge-primary">{{ b.isbn }}</span>
      </td>
      <td>{{ b.title }}</td>
      <td>{{ b.writer?.name }}</td>
      <td>
        <span class="badge badge-warning">{{ b.category?.category_name }}</span>
      </td>
      <td>{{ b.publisher?.name }}</td>
      <td>
        <button
          (click)="delete(b.id)"
          type=" button"
          class="btn btn-danger btn-sm"
          onclick="return confirm('Êtes-vous sûr de vouloir supprimer cet employé ?');"
        >
          <i class="fas fa-trash-alt"></i>
        </button>
      </td>
    </tr>
  </tbody>
</table> -->


<ngx-datatable
class="bootstrap"
[rows]="books"
[columnMode]="'force'"
[headerHeight]="50"
[footerHeight]="50"
[rowHeight]="'auto'"
[loadingIndicator]="loadingIndicator"
[reorderable]="reorderable"
>
<ngx-datatable-column name="Title" prop="title"></ngx-datatable-column>
<ngx-datatable-column name="ISBN" prop="isbn"></ngx-datatable-column>
<ngx-datatable-column name="Writer" prop="writer.name"></ngx-datatable-column>
<ngx-datatable-column name="Publisher" prop="publisher.name"></ngx-datatable-column>
<ngx-datatable-column name="Edition" prop="edition"></ngx-datatable-column>
<!-- <ngx-datatable-column name="Price" prop="price"></ngx-datatable-column> -->
<ngx-datatable-column name="Category" prop="category.category_name"></ngx-datatable-column>
<ngx-datatable-column name="Actions">
  <ng-template ngx-datatable-cell-template let-row="row">
    <!-- <button class="btn btn-sm btn-primary" (click)="edit(row)">Edit</button> -->
    <button class="btn btn-sm btn-outline-primary" (click)="openViewDialog(row)">View</button>
  </ng-template>
</ngx-datatable-column>
</ngx-datatable>
